import { createSlice } from "@reduxjs/toolkit";

const strChartSlice = createSlice({
  name: "strchart",
  initialState: {
    apiLoading: {
      treeMap: false,
      chart: false,
      kpi: false,
    },
    baseRiskData: [],
    weights: {},
    lineChartData: [],
    filteredLineChartData: [],
    treeMapData: [],
    resetTriggered: false,
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setBaseRiskData(state, action) {
      state.baseRiskData = action.payload;
    },
    setLineChartData(state, action) {
      state.lineChartData = action.payload;
    },
    setFilteredLineChartData(state, action) {
      state.filteredLineChartData = action.payload;
    },
    setTreeMapData(state, action) {
      const payload = action.payload;

      state.treeMapData = payload.map((d) => ({
        name: d.event_grp_id,
        size: d.comp_percentage,
      }));
    },
    setWeights(state, action) {
      state.weights = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
  },
});

export const {
  setLoader,
  setBaseRiskData,
  setLineChartData,
  setFilteredLineChartData,
  setTreeMapData,
  setWeights,
  setResetTriggered,
} = strChartSlice.actions;

export default strChartSlice.reducer;
